import React, { useEffect, useRef } from 'react'
import {
  Badge,
  Button,
  FormText,
  Input,
  InputGroup,
  InputGroupAddon,
} from 'reactstrap'
import { X } from 'react-feather'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'

import { Show } from '~/components/commons'

// const LabelsPreview = ({}) => {}

function LabelInput({
  value: labels = [],
  onChange,
  disabled,
  id,
  onChangeRemoveLabels,
  editableFields,
  switchId,
  ...props
}) {
  const labelInputRef = useRef(null)

  function handleAddLabel() {
    const newLabelValue = labelInputRef?.current?.value

    if (!newLabelValue) return

    onChange([...labels, newLabelValue])
    labelInputRef.current.value = ''
  }

  function handleRemoveLabel(id) {
    onChange(labels.filter((_, index) => id !== index))
  }

  useEffect(() => {
    onChangeRemoveLabels(!!editableFields[switchId])
  }, [editableFields, switchId, onChangeRemoveLabels])

  return (
    <div style={{ marginBottom: 5 }}>
      <InputGroup
        onKeyPress={e => {
          if (e.key === 'Enter') {
            e.preventDefault()
            handleAddLabel()
          }
        }}
      >
        <Input
          innerRef={labelInputRef}
          className="form-control"
          type="text"
          disabled={disabled}
          id={id}
          {...props}
        />
        <InputGroupAddon addonType="append">
          <Show condition={!disabled}>
            <Button
              onClick={handleAddLabel}
              type="button"
              color="primary"
              disabled={disabled}
              {...props}
            >
              <FormattedMessage id="Add" />
            </Button>
          </Show>
        </InputGroupAddon>
      </InputGroup>
      <Show condition={!disabled}>
        <FormText>
          <FormattedMessage id="Labels let you organize your locations into groups. They are not displayed to users. Editing it will replace all your current labels" />
        </FormText>
        <Show condition={labels.length > 0}>
          <LabelsContainer>
            {labels?.map((label, index) => (
              <FlexBadge color="primary" key={index}>
                {label}
                <Button color="link" onClick={() => handleRemoveLabel(index)}>
                  <X size={10} color="#fff" />
                </Button>
              </FlexBadge>
            ))}
          </LabelsContainer>
        </Show>
      </Show>
    </div>
  )
}

const FlexBadge = styled(Badge)`
  display: flex;
  align-items: center;
  width: fit-content;
  gap: 5px;

  button {
    padding: 0;
    align-items: center;
    display: flex;
  }
`

const LabelsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 5px;
`

export default LabelInput
